import * as consts from './FooterConsts';

const initialState = {
    disclaimer: '',
    poweredBy: {
        company: '',
        url: ''
    },
    localCompany: {
        company: '',
        url: ''
    }
};

const footer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default footer;
